module.exports = __webpack_public_path__ + "media/images/pic/lectors/gabriela-kwasniewska-c2b2bb02b4deb6c2cd9ec4fb2002d94a.jpeg";